import firebase from 'firebase';

// Configure FirebaseUI.
const Auth = {

	// Popup signin flow rather than redirect flow.
	signInFlow: 'popup',

	// Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
	signInSuccessUrl: '/',

	// We will display Google and Facebook as auth providers.
	signInOptions: [
		// firebase.auth.EmailAuthProvider.PROVIDER_ID,
		firebase.auth.FacebookAuthProvider.PROVIDER_ID
	],

	callbacks: {
		signInSuccess: () => {
			// console.log('signInSuccess');
			return false; // Avoid redirects after sign-in.
		}
	}
};

export default Auth;



// WEBPACK FOOTER //
// ./src/components/auth.js